import React from 'react';
import './styles.scss';
const NavbarDivider: React.FC = () => {
  return <div className="navbar-divider" />;
};

export default NavbarDivider;
